import { testimonials } from '@/mocks/comics';

export default function TestimonialSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="lg:w-[58%]">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-2 h-2 rounded-full bg-stone-800"></span>
              <span className="text-xs font-medium text-stone-500 uppercase tracking-wider">漫迷口碑</span>
            </div>

            <blockquote className="text-xl md:text-2xl font-[family-name:var(--font-heading)] text-stone-800 leading-relaxed max-w-lg">
              &ldquo;韩漫屋是我每天必刷的漫画平台，更新速度真的很快，画质也超级清晰。推荐给所有喜欢韩漫的朋友！&rdquo;
            </blockquote>

            <div className="mt-6 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-stone-200">
                <img src={testimonials[0].avatar} alt={testimonials[0].author} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div>
                <p className="text-sm font-semibold text-stone-800">{testimonials[0].author}</p>
                <div className="flex items-center gap-1.5">
                  <span className="text-xs text-stone-400">{testimonials[0].role}</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-verified-badge-fill text-green-500 text-sm"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:w-[42%] grid grid-cols-1 gap-5">
            {testimonials.slice(1).map((t) => (
              <div key={t.author} className="flex gap-4 p-5 rounded-xl bg-stone-50 hover:bg-stone-100 transition-colors">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-stone-200 flex-shrink-0 mt-0.5">
                  <img src={t.avatar} alt={t.author} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <p className="text-sm text-stone-600 leading-relaxed">{t.quote}</p>
                  <div className="mt-2 flex items-center gap-2">
                    <span className="text-xs font-medium text-stone-800">{t.author}</span>
                    <span className="text-xs text-stone-400">· {t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}